module.exports = __webpack_public_path__ + "img/i_media_tracker-3.8084b264.png";